import { render, staticRenderFns } from "./YouAndMeText.vue?vue&type=template&id=37b4f9c1&scoped=true&"
import script from "./YouAndMeText.vue?vue&type=script&lang=js&"
export * from "./YouAndMeText.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeText.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YouAndMeText.vue?vue&type=style&index=1&id=37b4f9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4f9c1",
  null
  
)

export default component.exports